<template>
  <v-navigation-drawer app v-model="drawer">
    <v-list-item>
      <v-list-item-avatar color="primary">
        <v-icon dark>mdi-truck-fast</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="text-h6">Istat <span class="font-weight-medium">TMS</span></v-list-item-title>
        <v-list-item-subtitle>Trasporto merci su strada</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list nav>
      <v-list-item link disabled to="/admin/dashboard">
        <v-list-item-icon>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>

      <v-list-item link to="/admin/surveys">
        <v-list-item-icon>
          <v-icon>mdi-file-document-multiple-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Questionari</v-list-item-title>
      </v-list-item>

      <v-list-item link disabled>
        <v-list-item-icon>
          <v-icon>mdi-account-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Utenti</v-list-item-title>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list nav bottom>
        <v-list-item link disabled>
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Impostazioni</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
// Store
import { mapGetters, mapActions } from 'vuex'

// Component
export default {
  name: 'TheAdminNavigationDrawer',
  components: {},

  data: () => ({
    mini: true,
  }),
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('layout', ['setDrawerVisibility']),

    async onLogout() {
      await this.logout()
      await this.$router.push('/')
    },
  },
  computed: {
    ...mapGetters('layout', ['getDrawerVisibility']),
    drawer: {
      get() {
        return this.getDrawerVisibility
      },
      set(value) {
        this.setDrawerVisibility(value)
      },
    },
  },
}
</script>
